import type { Template } from "@/types";

export const PO_05_H1_V4: Template[] = [
    {
        id: "po-05-h1v4-01",
        name: "PO 01 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 47, y: 256, width: 593, height: 404, rotation: 0, imageRotation: 0 },
            { id: "2", x: 835, y: 167, width: 192, height: 287, rotation: 0, imageRotation: 0 },
            { id: "3", x: 835, y: 462, width: 192, height: 287, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1035, y: 167, width: 192, height: 287, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1035, y: 462, width: 192, height: 287, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "po-05-h1v4-02",
        name: "PO 02 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 47, y: 256, width: 593, height: 404, rotation: 0, imageRotation: 0 },
            { id: "2", x: 742, y: 124, width: 422, height: 668, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1172, y: 124, width: 146, height: 217, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1172, y: 349, width: 146, height: 217, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1172, y: 574, width: 146, height: 216, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "po-05-h1v4-03",
        name: "PO 03 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 66, y: 131, width: 554, height: 368, rotation: 0, imageRotation: 0 },
            { id: "2", x: 66, y: 506, width: 180, height: 280, rotation: 0, imageRotation: 0 },
            { id: "3", x: 254, y: 506, width: 179, height: 280, rotation: 0, imageRotation: 0 },
            { id: "4", x: 441, y: 506, width: 179, height: 280, rotation: 0, imageRotation: 0 },
            { id: "5", x: 785, y: 102, width: 491, height: 698, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "po-05-h1v4-04",
        name: "PO 04 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 59, y: 202, width: 312, height: 512, rotation: 0, imageRotation: 0 },
            { id: "2", x: 379, y: 202, width: 250, height: 166, rotation: 0, imageRotation: 0 },
            { id: "3", x: 379, y: 375, width: 250, height: 339, rotation: 0, imageRotation: 0 },
            { id: "4", x: 754, y: 253, width: 271, height: 410, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1033, y: 253, width: 271, height: 410, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "po-05-h1v4-05",
        name: "PO 05 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 70, y: 253, width: 271, height: 410, rotation: 0, imageRotation: 0 },
            { id: "2", x: 349, y: 253, width: 271, height: 410, rotation: 0, imageRotation: 0 },
            { id: "3", x: 745, y: 202, width: 312, height: 512, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1065, y: 202, width: 250, height: 339, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1065, y: 548, width: 250, height: 166, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "po-05-h1v4-06",
        name: "PO 06 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 107, y: 108, width: 472, height: 699, rotation: 0, imageRotation: 0 },
            { id: "2", x: 745, y: 412, width: 570, height: 370, rotation: 0, imageRotation: 0 },
            { id: "3", x: 745, y: 134, width: 185, height: 270, rotation: 0, imageRotation: 0 },
            { id: "4", x: 938, y: 134, width: 185, height: 270, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1131, y: 134, width: 184, height: 270, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "po-05-h1v4-07",
        name: "PO 07 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 32, y: 151, width: 196, height: 303, rotation: 0, imageRotation: 0 },
            { id: "2", x: 32, y: 462, width: 196, height: 302, rotation: 0, imageRotation: 0 },
            { id: "3", x: 236, y: 151, width: 196, height: 303, rotation: 0, imageRotation: 0 },
            { id: "4", x: 236, y: 462, width: 196, height: 302, rotation: 0, imageRotation: 0 },
            { id: "5", x: 440, y: 151, width: 901, height: 613, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "po-05-h1v4-08",
        name: "PO 08 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 242, width: 652, height: 432, rotation: 0, imageRotation: 0 },
            { id: "2", x: 660, y: 242, width: 279, height: 432, rotation: 0, imageRotation: 0 },
            { id: "3", x: 947, y: 242, width: 140, height: 212, rotation: 0, imageRotation: 0 },
            { id: "4", x: 947, y: 462, width: 140, height: 212, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1095, y: 242, width: 279, height: 432, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "po-05-h1v4-09",
        name: "PO 09 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 242, width: 652, height: 432, rotation: 0, imageRotation: 0 },
            { id: "2", x: 660, y: 242, width: 279, height: 432, rotation: 0, imageRotation: 0 },
            { id: "3", x: 947, y: 242, width: 279, height: 432, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1234, y: 242, width: 140, height: 212, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1234, y: 462, width: 140, height: 212, rotation: 0, imageRotation: 0 }
        ],
    },


];

